import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../common/modal/Modal";
import PlanCard from "../../../../../common/plan-card/PlanCard";

export const AddChapterMaxReachedModal = ({
  modalId,
  addExtraChapterPlan,
  onChooseAddChapterPlanClick,
}) => (
  <Modal id={modalId}>
    <div className="container">
      {addExtraChapterPlan?.length > 0 &&
        addExtraChapterPlan.map((item, index) => (
          <PlanCard
            key={index}
            item={item}
            onButtonClick={onChooseAddChapterPlanClick}
          />
        ))}
    </div>
  </Modal>
);

export const ConfirmAnswersModal = ({ modalId, onCancelWriteStory }) => {
  const { t } = useTranslation();

  return (
    <Modal id={modalId}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="aai-section-title mb-3 text-center mb-5">
              <h2 className="section-title">Warning</h2>
              <p className="section-desc">
                You can generate once, so make sure of the texts set!
              </p>
              <div className="mt-4">
                <button className="aai-gradient-outline-btn me-4">
                  Generate
                </button>
                <button
                  className="aai-btn btn-pill-solid"
                  onClick={onCancelWriteStory}
                >
                  {t("cancel")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const UpsertChapterModal = ({
  modalId,
  chapterToUpsert,
  loading,
  onChapterToUpsertChange,
  onSubmitChapterToUpsert,
}) => {
  const { t } = useTranslation();

  return (
    <Modal id={modalId}>
      <div className="container">
        <div className="row g-3">
          <div className="col-lg-12">
            <div className="aai-form-container">
              <h4 className="aai-testimonial-author-name mb-2">
                {t("chapter_title")}
              </h4>
              <input
                className="form-control shadow-none"
                type="text"
                placeholder={t("add_your_chapter_title")}
                value={chapterToUpsert?.name ?? ""}
                onChange={onChapterToUpsertChange("chapter-change-text", null)}
              />
            </div>
            <div className="aai-form-container">
              <div className="d-flex align-items-center  mt-4 mb-2">
                <h4 className="aai-testimonial-author-name">
                  {t("questions")}
                </h4>
                <button
                  className="aai-breadcrumb-link text-decoration-underline ms-2"
                  onClick={onChapterToUpsertChange("question-add-text", null)}
                  style={{ fontSize: "16px" }}
                >
                  {t("add")} <span style={{ fontSize: "1.2rem" }}>+</span>
                </button>
              </div>
              {chapterToUpsert?.questions?.map(
                (chap_question_item, chap_question_index) => (
                  <div
                    key={"chapter-upsert-" + chap_question_index}
                    className="d-flex align-items-center mb-2"
                  >
                    <input
                      className="form-control shadow-none "
                      type="text"
                      placeholder={t("add_your_question_title")}
                      value={chap_question_item?.name ?? ""}
                      onChange={onChapterToUpsertChange(
                        "question-change-text",
                        chap_question_index
                      )}
                    />
                    <div className="dropdown">
                      <button
                        style={{ marginLeft: "1rem" }}
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i
                          className="fa-solid fa-trash icons"
                          style={{ color: "#FF2A09" }}
                        />
                      </button>
                      <ul className="dropdown-menu">
                        <li
                          onClick={onChapterToUpsertChange(
                            "question-delete-text",
                            chap_question_index
                          )}
                        >
                          <span className="dropdown-item">{t("yes")}</span>
                        </li>
                        <li>
                          <span className="dropdown-item">{t("no")}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )
              )}
            </div>
            <button
              className="aai-btn btn-pill-solid mt-2"
              disabled={loading}
              onClick={onSubmitChapterToUpsert}
            >
              {t("submit")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const DeleteChapterModal = ({
  modalId,
  onClickDeleteChapter,
  showHideModal,
}) => {
  const { t } = useTranslation();

  return (
    <Modal id={modalId}>
      <div className="container">
        <div>
          <h2 className="section-title mb-4 text-center">
            {t("are_you_sure_you_want_to_delete_this_chapter")}?
          </h2>
          <div className="d-flex justify-content-center">
            <button
              className="aai-btn btn-pill-solid me-4"
              onClick={() => showHideModal(modalId)}
            >
              {t("cancel")}
            </button>
            <button
              className="aai-gradient-outline-btn"
              onClick={onClickDeleteChapter}
            >
              {t("delete")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const DeleteQuestionModal = ({
  modalId,
  onClickDeleteQuestion,
  showHideModal,
}) => {
  const { t } = useTranslation();

  return (
    <Modal id={modalId}>
      <div className="container">
        <div>
          <h2 className="section-title mb-4 text-center">
            {t("are_you_sure_you_want_to_delete_this_question")}?
          </h2>
          <div className="d-flex justify-content-center">
            <button
              className="aai-btn btn-pill-solid me-4"
              onClick={() => showHideModal(modalId)}
            >
              {t("cancel")}
            </button>
            <button
              className="aai-gradient-outline-btn"
              onClick={onClickDeleteQuestion}
            >
              {t("delete")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const UpsertQuestionModal = ({
  modalId,
  questionToUpsert,
  onQuestionToUpsertChange,
  onClickEditAddQuestion,
  showHideModal,
}) => {
  const { t } = useTranslation();

  return (
    <Modal id={modalId}>
      <div className="container">
        <div>
          <h2 className="section-title mb-4 text-center">
            {t("edit_this_question")}
          </h2>
          <input
            className="form-control shadow-none "
            type="text"
            placeholder="Enter your question"
            value={questionToUpsert?.name ?? ""}
            onChange={onQuestionToUpsertChange}
          />
          <div className="d-flex justify-content-center mt-4">
            <button
              className="aai-btn btn-pill-solid me-4"
              onClick={() => showHideModal(modalId)}
            >
              {t("cancel")}
            </button>
            <button
              className="aai-gradient-outline-btn"
              onClick={onClickEditAddQuestion}
            >
              {t("submit")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export const SubmitChapterChangesModal = ({
  modalId,
  survey_questions,
  onSurveyAnswerClick,
  showHideModal,
  onSubmit,
  i18n,
}) => {
  const { t } = useTranslation();

  return (
    <Modal id={modalId}>
      <div className="container">
        <div>
          <h2 className="section-title mb-4 text-center">
            {t("check_spelling_before_generating_chapter")}
          </h2>
          <div>
            {survey_questions.map((item, index) => (
              <div key={"survey_question_" + index} className="mb-3">
                <h4 className="writing-step-title">
                  {index + 1 + "- " + item?.name}
                </h4>
                {item.survey_answers.map((answer_item, answer_index) => (
                  <p
                    key={"survey_answer_" + answer_index}
                    className="aai-price-list-item-text cursor-pointer"
                    onClick={onSurveyAnswerClick(index, answer_index)}
                  >
                    <i
                      className={
                        "fa-regular fa-circle" +
                        (answer_item?.is_selected ? "-check" : "")
                      }
                    ></i>{" "}
                    {answer_item?.name}
                  </p>
                ))}
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-center">
            <button
              className="aai-gradient-outline-btn me-4"
              onClick={() => showHideModal(modalId)}
            >
              {t("review")}
            </button>
            <button className="aai-gradient-outline-btn" onClick={onSubmit}>
              {i18n.language === "it" ? t("create") : t("submit")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
